var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "sub-tab-ui-wrapper",
        attrs: { id: "byoglTabUiGroup" + _vm.sectionId + _vm.rowId },
      },
      [
        !!_vm.tableFormat.features.includes("genes in list")
          ? _c(
              "div",
              {
                staticClass: "tab-ui-tab active",
                attrs: { id: "byoglTabUi" + _vm.sectionId + _vm.rowId + "0" },
                on: {
                  click: function ($event) {
                    return _vm.utils.uiUtils.setTabActive(
                      "byoglTabUi" + _vm.sectionId + _vm.rowId + "0",
                      "byoglTabUiGroup" + _vm.sectionId + _vm.rowId,
                      "byoglTabContent" + _vm.sectionId + _vm.rowId + "0",
                      "byoglTabContentGroup" + _vm.sectionId + _vm.rowId
                    )
                  },
                },
              },
              [_vm._v(" Genes predicted to be in your gene list")]
            )
          : _vm._e(),
        !!_vm.tableFormat.features.includes("cfde gene set")
          ? _c(
              "div",
              {
                staticClass: "tab-ui-tab",
                attrs: { id: "byoglTabUi" + _vm.sectionId + _vm.rowId + "1" },
                on: {
                  click: function ($event) {
                    return _vm.utils.uiUtils.setTabActive(
                      "byoglTabUi" + _vm.sectionId + _vm.rowId + "1",
                      "byoglTabUiGroup" + _vm.sectionId + _vm.rowId,
                      "byoglTabContent" + _vm.sectionId + _vm.rowId + "1",
                      "byoglTabContentGroup" + _vm.sectionId + _vm.rowId
                    )
                  },
                },
              },
              [
                _vm._v(
                  " CFDE gene sets that predict membership in your gene list"
                ),
              ]
            )
          : _vm._e(),
        !!_vm.tableFormat.features.includes("human traits")
          ? _c(
              "div",
              {
                staticClass: "tab-ui-tab",
                attrs: { id: "byoglTabUi" + _vm.sectionId + _vm.rowId + "2" },
                on: {
                  click: function ($event) {
                    return _vm.utils.uiUtils.setTabActive(
                      "byoglTabUi" + _vm.sectionId + _vm.rowId + "2",
                      "byoglTabUiGroup" + _vm.sectionId + _vm.rowId,
                      "byoglTabContent" + _vm.sectionId + _vm.rowId + "2",
                      "byoglTabContentGroup" + _vm.sectionId + _vm.rowId
                    )
                  },
                },
              },
              [_vm._v(" Human traits that share genes with your input list")]
            )
          : _vm._e(),
      ]
    ),
    _c(
      "div",
      { attrs: { id: "byoglTabContentGroup" + _vm.sectionId + _vm.rowId } },
      [
        !!_vm.geneScores
          ? _c(
              "div",
              {
                staticClass: "tab-content-wrapper",
                attrs: {
                  id: "byoglTabContent" + _vm.sectionId + _vm.rowId + "0",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-sm table-striped research-data-table subsection-table",
                  },
                  [
                    _vm._m(0),
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.getSubPageData(_vm.geneScores, _vm.tab0Page),
                          function (row, rowIndex) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(row["gene"]))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.utils.Formatters.pValueFormatter(
                                      row["score"]
                                    )
                                  )
                                ),
                              ]),
                            ])
                          }
                        ),
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: "2" } },
                            [
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-left",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        "Total rows: " + _vm.geneScores.length
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-center",
                                },
                                [
                                  _c("b-pagination", {
                                    staticClass:
                                      "pagination-sm justify-content-center",
                                    attrs: {
                                      "total-rows": _vm.geneScores.length,
                                      "per-page": _vm.numberOfRows,
                                      phenotypeMap: _vm.phenotypeMap,
                                    },
                                    model: {
                                      value: _vm.tab0Page,
                                      callback: function ($$v) {
                                        _vm.tab0Page = $$v
                                      },
                                      expression: "tab0Page",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-right",
                                },
                                [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v("Save data in section: "),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "convert-2-csv btn-sm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.convertJson2Csv(
                                              _vm.geneScores,
                                              _vm.rowId + "_geneScores"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" CSV ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "convert-2-csv btn-sm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveJson(
                                              _vm.geneScores,
                                              _vm.rowId + "_geneScores"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" JSON ")]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        !!_vm.geneSetScores
          ? _c(
              "div",
              {
                staticClass: "tab-content-wrapper hidden-content",
                attrs: {
                  id: "byoglTabContent" + _vm.sectionId + _vm.rowId + "1",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-sm table-striped research-data-table subsection-table",
                  },
                  [
                    _vm._m(1),
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.getSubPageData(_vm.geneSetScores, _vm.tab1Page),
                          function (row, rowIndex) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(row["geneSet"]))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.utils.Formatters.pValueFormatter(
                                      row["score"]
                                    )
                                  )
                                ),
                              ]),
                            ])
                          }
                        ),
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: "2" } },
                            [
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-left",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        "Total rows: " +
                                          _vm.geneSetScores.length
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-center",
                                },
                                [
                                  _c("b-pagination", {
                                    staticClass:
                                      "pagination-sm justify-content-center",
                                    attrs: {
                                      "total-rows": _vm.geneSetScores.length,
                                      "per-page": _vm.numberOfRows,
                                      phenotypeMap: _vm.phenotypeMap,
                                    },
                                    model: {
                                      value: _vm.tab1Page,
                                      callback: function ($$v) {
                                        _vm.tab1Page = $$v
                                      },
                                      expression: "tab1Page",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-right",
                                },
                                [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v("Save data in section: "),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "convert-2-csv btn-sm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.convertJson2Csv(
                                              _vm.geneSetScores,
                                              _vm.rowId + "_geneSetScores"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" CSV ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "convert-2-csv btn-sm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveJson(
                                              _vm.geneSetScores,
                                              _vm.rowId + "_geneSetScores"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" JSON ")]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        !!_vm.humanTraits
          ? _c(
              "div",
              {
                staticClass: "tab-content-wrapper hidden-content",
                attrs: {
                  id: "byoglTabContent" + _vm.sectionId + _vm.rowId + "2",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-sm table-striped research-data-table subsection-table",
                  },
                  [
                    _vm._m(2),
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.getSubPageData(_vm.humanTraits, _vm.tab2Page),
                          function (row, rowIndex) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(row["phenotype"]))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.utils.Formatters.pValueFormatter(
                                      row["p_value"]
                                    )
                                  )
                                ),
                              ]),
                            ])
                          }
                        ),
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: "2" } },
                            [
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-left",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        "Total rows: " + _vm.humanTraits.length
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-center",
                                },
                                [
                                  _c("b-pagination", {
                                    staticClass:
                                      "pagination-sm justify-content-center",
                                    attrs: {
                                      "total-rows": _vm.humanTraits.length,
                                      "per-page": _vm.numberOfRows,
                                      phenotypeMap: _vm.phenotypeMap,
                                    },
                                    model: {
                                      value: _vm.tab2Page,
                                      callback: function ($$v) {
                                        _vm.tab2Page = $$v
                                      },
                                      expression: "tab2Page",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-container",
                                {
                                  staticClass:
                                    "egl-table-page-ui-wrapper subsection-page-ui-right",
                                },
                                [
                                  _c("div", [
                                    _c("strong", [
                                      _vm._v("Save data in section: "),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "convert-2-csv btn-sm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.convertJson2Csv(
                                              _vm.humanTraits,
                                              _vm.rowId + "_humanTraitsScores"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" CSV ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "convert-2-csv btn-sm",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveJson(
                                              _vm.humanTraits,
                                              _vm.rowId + "_humanTraitsScores"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" JSON ")]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" Gene ")]),
        _c("th", [_vm._v(" Predicted probability ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" Gene set ")]),
        _c("th", [_vm._v(" Marginal effect ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" Phenotype ")]),
        _c("th", [_vm._v(" P-value ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }